module.exports = __webpack_public_path__ + "static/media/4.d192ae9b.jpg";